module.exports = __webpack_public_path__ + "static/media/btc-icon.59c9c26b.png";